import React from 'react';
import { Images } from 'utils';
import { getSubmittedDetails } from './core/constants';

export const SignatureSubmitted = ({ request }) => {
    const details = getSubmittedDetails(request);

    return (
        <div className="signature-submitted">
            <div className="signature-submitted-icon">
                <img src={Images.signedSuccessCheck} alt="submitted" />
            </div>

            <p className="signature-submitted-title">Signature Submitted</p>
            <p className="signature-submitted-subtitle">
                Thank you! Your signature has been successfully submitted for this appointment.
            </p>

            <div className="signature-submitted-card">
                <p className="signature-submitted-card-title">Appointment Details</p>
                {details.map((detail) => (
                    <div key={detail.label} className="signature-submitted-row">
                        <p className='signature-submitted-row-label'>{detail.label}</p>
                        <p className='signature-submitted-row-value'>{detail.value}</p>
                    </div>
                ))}
            </div>

            <div className="signature-submitted-note">
                <img src={Images.shieldTickGray} alt="secure" />
                <p className='signature-submitted-note-title'>Your signature has been securely recorded and sent to your care provider through TherapyLake.</p>
            </div>
        </div>
    );
};
